/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CloneRevision
 */
export interface CloneRevision {
  /**
   * The schematisation id to clone the revision to
   */
  schematisationId?: number;
  /**
   *
   */
  schematisationName?: string;
  /**
   * Optional description for the new schematisation
   */
  schematisationDescription?: string;
  /**
   * Optional rana project id (only superusers can modify this field)
   */
  ranaProjectId?: string | null;
  /**
   * Optional rana tenant id (only superusers can modify this field)
   */
  ranaTenantId?: string | null;
  /**
   * Optional created_by cognito UUID (only superusers can modify this field)
   */
  createdBy?: string;
}

/**
 * Check if a given object implements the CloneRevision interface.
 */
export function instanceOfCloneRevision(value: object): value is CloneRevision {
  return true;
}

export function CloneRevisionFromJSON(json: any): CloneRevision {
  return CloneRevisionFromJSONTyped(json, false);
}

export function CloneRevisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloneRevision {
  if (json == null) {
    return json;
  }
  return {
    schematisationId: json["schematisation_id"] == null ? undefined : json["schematisation_id"],
    schematisationName:
      json["schematisation_name"] == null ? undefined : json["schematisation_name"],
    schematisationDescription:
      json["schematisation_description"] == null ? undefined : json["schematisation_description"],
    ranaProjectId:
      json["rana_project_id"] === undefined
        ? undefined
        : json["rana_project_id"] === null
        ? null
        : json["rana_project_id"],
    ranaTenantId:
      json["rana_tenant_id"] === undefined
        ? undefined
        : json["rana_tenant_id"] === null
        ? null
        : json["rana_tenant_id"],
    createdBy: json["created_by"] == null ? undefined : json["created_by"],
  };
}

export function CloneRevisionToJSON(json: any): CloneRevision {
  return CloneRevisionToJSONTyped(json, false);
}

export function CloneRevisionToJSONTyped(
  value?: CloneRevision | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    schematisation_id: value["schematisationId"],
    schematisation_name: value["schematisationName"],
    schematisation_description: value["schematisationDescription"],
    rana_project_id: value["ranaProjectId"],
    rana_tenant_id: value["ranaTenantId"],
    created_by: value["createdBy"],
  };
}
